var a;!function(a){a.AutomaticLocal="automaticLocal",a.AutomaticGlobal="automaticGlobal",a.Manual="manual",a.Formula="formula"}(a||(a={}));export{a as Mode};
